exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-chapter-list .ds-section-headline{display:flex;flex-direction:column;margin:0 0 .5rem 1.3125rem}.ds-chapter-list__item{border-top:var(--ds-border-rule);margin:0;padding:.625rem 0 .5rem}.ds-chapter-list__item .ds-link-with-arrow{max-width:31rem}", ""]);

// exports
exports.locals = {
	"ds-chapter-list": "ds-chapter-list",
	"ds-section-headline": "ds-section-headline",
	"ds-chapter-list__item": "ds-chapter-list__item",
	"ds-link-with-arrow": "ds-link-with-arrow"
};